import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

function OnboardCpa(props) {
  const cpa_status = useSelector((state) => state.auth.user?.account_status);

  // New 4-step onboarding flow
  if (cpa_status === "TN") {
    return <Navigate to="onboarding-test" />;
  } else if (
    cpa_status === "DN" ||
    cpa_status === "LV" ||
    cpa_status === "LR"
  ) {
    return <Navigate to="provide-license" />;
  } else if (cpa_status === "CA") {
    // Avoid redirecting while success modal is open
    try {
      const block = sessionStorage.getItem("block_auto_redirect") === "true";
      if (!block) {
        window.location.href = "onboard/connected-account";
      }
    } catch (e) {
      window.location.href = "onboard/connected-account";
    }
  } else if (cpa_status === "LE") {
    return <Navigate to="onboarding-legal" />;
  }

  // If fully onboarded (AC), redirect to main profile
  if (cpa_status === "AC") {
    return <Navigate to="/" />;
  }
}

export default OnboardCpa;
